module.exports = __webpack_public_path__ + "img/img24.b0f64f41.png";